<div class="body-login">
  <div class="container">
            <!-- BRAND LOGO AND COPY -->
            <div class="mylogo col-12" >
              <img src="../../../../assets/img/logo.png" width="100%">
            </div>
            <br><br>
            <!-- LOGIN BOX -->
            <form autocomplete="off" class="login-content" [formGroup]="formLogin" (ngSubmit)="onLogin()">
                <div class="col-12 form-group">
                  <label><i class="fa fa-user"></i> Usuario</label>
                  <input class="form-control"
                      type="email"
                      formControlName="correo"
                      placeholder="Email"
                      [class.is-invalid]="correoNoValido">

                  <small *ngIf="correoNoValido"
                      class="form-text text-danger">
                      Ingrese un Email Valido
                  </small>
                </div>

                <div class="col-12 form-group">
                  <label> <i class="fa fa-unlock-alt"></i> Contraseña</label>
                  <div class="password input-group">
                    <input class="form-control"
                          [type]="verPass"
                        formControlName="password"
                        placeholder="Password"
                        [class.is-invalid]="passwordNoValido">
                        <button class="btn btn-outline-secondary" type="button" id="verClave" (mousedown)='claveVisible()' (mouseup)='claveOculta()'>
                          <i class="fa" [ngClass]="{'fa-eye': verPass === 'password', 'fa-eye-slash': verPass === 'text'}" ></i>
                        </button>

                    <small *ngIf="passwordNoValido"
                      class="form-text text-danger">
                      El Password debe ser mayor de 4 caracteres
                    </small>
                  </div>
                </div>
                <div class="col-12 form-group text-center">
                  <button type="submit" class="form-control btn-primary">Entrar</button>
                </div>
            </form>
    </div>
  </div>
  
  <app-footer></app-footer>
  
  
